import { SymbolType } from '@ritabygglov/core';
import {
  DrillWholeIcon,
  GeneralWellIcon,
  SymbolIconProps,
  ThreeChamberWellIcon,
  WellIcon,
} from '../components/Icons';
import {
  DrillHoleIcon,
  GenerelWellIcon,
  ThreeChamberWellIcon as ThreeChamberWellToolbarIcon,
  WellIcon as WellToolbarIcon,
} from '../components/Toolbar/SvgIcons';

// ─── Symbol definition ────────────────────────────────────────────────────────

export type SymbolDefinition = {
  defaultWidth: number;
  defaultHeight: number;
  /** Icon used for canvas rendering — accepts SymbolIconProps (x, y, id, style, scale). */
  canvasIcon: React.FC<SymbolIconProps>;
  /** Icon used for the toolbar thumbnail — accepts isFill for active/inactive state. */
  toolbarIcon: React.FC<{ isFill: boolean }>;
  /** i18n message id for the toolbar label. */
  i18nKey: string;
};

// ─── Registry ─────────────────────────────────────────────────────────────────

/**
 * Single source of truth for all symbol type metadata.
 * TypeScript's exhaustive Record check ensures every SymbolType variant has an
 * entry — adding a new variant to the enum immediately produces a compile error here.
 * Declaration order defines the toolbar display order.
 */
export const symbolRegistry: Record<SymbolType, SymbolDefinition> = {
  [SymbolType.GENERAL_WELL]: {
    defaultWidth: 32,
    defaultHeight: 32,
    canvasIcon: GeneralWellIcon,
    toolbarIcon: WellToolbarIcon,
    i18nKey: 'toolbar.symbolGeneralWell',
  },
  [SymbolType.WELL]: {
    defaultWidth: 32,
    defaultHeight: 32,
    canvasIcon: WellIcon,
    toolbarIcon: GenerelWellIcon,
    i18nKey: 'toolbar.symbolWell',
  },
  [SymbolType.DRILL_HOLE]: {
    defaultWidth: 32,
    defaultHeight: 32,
    canvasIcon: DrillWholeIcon,
    toolbarIcon: DrillHoleIcon,
    i18nKey: 'toolbar.symbolDrillHole',
  },
  [SymbolType.THREE_CHAMBER_WELL]: {
    defaultWidth: 32,
    defaultHeight: 32,
    canvasIcon: ThreeChamberWellIcon,
    toolbarIcon: ThreeChamberWellToolbarIcon,
    i18nKey: 'toolbar.symbolThreeChamberWell',
  },
};
